import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import Tilt from "react-tilt"

const TheCard = () => {
  const data = useStaticQuery(graphql`
    query {
      thecard: file(relativePath: { eq: "animate-card.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Tilt
      className="Tilt"
      options={{ max: 15, glare: false, scale: 1 }}
      style={{ height: 250, width: 250 }}
    >
      <div
        // style={{ width: "500px" }}
        className="mx-auto Tilt-inner tilt-logo-inner"
      >
        <Img fluid={data.thecard.childImageSharp.fluid} />
      </div>
    </Tilt>
  )
}

export default TheCard
